// extracted by mini-css-extract-plugin
module.exports = {"root":"PetStore_root__TjAx_","details":"PetStore_details__PQwPA","content":"PetStore_content__NLZkp","tag":"PetStore_tag__yCkKG","image":"PetStore_image__z7qh5"};